// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1497551b","239":"7bd7f69a","732":"1f4ea1c8","977":"532d8d5b"}[chunkId] + ".chunk.js";
};